// extracted by mini-css-extract-plugin
export var card = "_jw-5";
export var cardSelected = "_jw-4";
export var image = "_jw-3";
export var modal = "_jw-0";
export var modalContent = "_jw-1";
export var table = "_jw-2";